var mojeKonto = false;
var cartRefresh=false;
var savedBankListNotEmpty = false;

function submitfastOrderForm(that){
	if($('#loginForm').valid()){
		refreshCsrfTokenAndSubmit($('#loginForm'));
	}
}
function fastOrderLoginView(){
	$('#form1 .errorBox').errorBox();
	$('#loginForm').ajaxForm({
		target:'#fancybox-content > div',
		success:function(){
			fastOrderLoginView();
		}
	}).validate({
		rules:{
			"j_password":{
				required:true
			}
		},
		messages:{
			"j_password":{
				required:"Podaj hasło"
			}
		}
	});
}

function frontLoginValidate() {		//pgrzech - validacja formularza logowania rejstracji
	if(!mojeKonto){
		$('#j_username, #j_password, #captcha').keyup(function(event){
			if(event.keyCode == 13){
				zaloguj();
			}
		});
	}else{
		$('#j_username').keyup(function(event){
			if(event.keyCode == 13){
				nextLogin();
			}
		});
		$('#j_password').keyup(function(event){
			if(event.keyCode == 13){
				zaloguj();
			}
		});

	}
	fancyRegulamin();
	$("#loginForm").validate({
		rules:{
			j_username: {
				required:true,
				trim:true
			},
			j_password: {
				required:true,
				minlength: 5
			},
			captcha:{
				required:true
			},
			"g-recaptcha-response":{
				required:true
			}
		},
		messages:{
			j_username: {
				required:'Podaj login(e-mail)',
				trim:'Pole nie może zawierać spacji'
			},
			j_password: {
				required:'Podaj hasło',
				minlength: 'Hasło jest za krótkie'
			},
			captcha:{
				required:'Podaj tekst z obrazka'
			},
			"g-recaptcha-response":{
				required: 'Prosimy zaznacz nie jestem robotem'
			}
		}
	});
	if(mojeKonto){
		$("#j_username").rules('add', {
			email:true
		});
	}
	$('#regAck').click(function(){
		setTimeout(function(){
			$("#registerForm").validate().element('#regAck');
		},100);
	});
	passwordInvalid.init($('#password'), $('#password').parents().find('.password-invalid'), $('#password').closest('.row'), $('#email'));
	$("#registerForm").validate({
		rules:{
			firstname: {
				required: true,
				minlength: 2,
				firstname: true
			},
			surname: {
				required: true,
				minlength: 2,
				surname: true
			},
			password: {
				strongPassword: true
			},
			password2:{
				required: true,
				equalTo: "#password"
			},
			email:{
				required: true,
				email: true
			},
			statuteAccepted: "required",
			"g-recaptcha-response":{
				required:true
			}
		},
		messages:{
			firstname: {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			surname: {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			password2:{
				required: 'Powtórz hasło',
				equalTo: 'Hasła muszą być identyczne'
			},
			//email weryfikowany JSON'em patrz jquery.validate.js validateEmail(mail)
			email:{
				required: 'Podaj adres e-mail',
				email: 'Podaj poprawny adres e-mail'
			},
			statuteAccepted: 'Akceptacja Regulaminu jest wymagana',
			"g-recaptcha-response":{
				required: 'Prosimy zaznacz nie jestem robotem'
			}
		}
	});
}

function checkOccupiedEmail(emailVal){
	$('#occupiedEmailLoading').show();
	$.ajax({
		url: '/front-user-account-exist.ltr',
		dataType: 'json',
		async: false,
		data: {
			email: emailVal
		},
		success:function(json){
			$('#occupiedEmailLoading').hide();
			if (json.exists) {
				simpleLogin(false);
			}
		},error:function(){
			$('#occupiedEmailLoading').hide();
		}
	});
}

function promotedLayer(href){
	clearTimeout(hideTimer);
	container.css('display', 'none');
	$.fancybox({href:href},{
		width: 720,
		padding:0,
		height: 400,
		titleShow:false,
		type:'iframe'
	});
}


function moreAccessories(groupId, linkName){
	const modalId = `show-product-accessories`;
	const $modal = document.querySelector(`#${modalId}.remodal-is-opened`);
	let url = `/product-card-access-in-cart.ltr`;
	let productLinkName = linkName || $('#producAccessoriesLinkName').val()

	url += `?product-link-name=${productLinkName}`;

	if(groupId){
		url += `&group-id=${groupId}`;
	}

	loadingStart();
	$.ajax({
		url,
		success: function(result){
			if($modal){
				$('#modal-content-all-accessories').html(result);
			}else{
				app.showModal({
					id: modalId,
					content: `<div id="modal-content-all-accessories">${result}</div>`
				});
			}
			$('#producAccessoriesLinkName').val(productLinkName);
			loadingStop();
		},
		error: function(){
			app.closeModal();
			loadingStop();
		}
	})
}
function showProductAccessories(){
	$('.accessoriesLink').click(function(){
		moreAccessories(false, $(this).attr('rel'));
	});
}
function addAccessoriesFromCart(id){
	loadingStart();
	addToCard(id,'','ACCESS_CARD');
	cartRefresh=true;
	$('.addedToCart.product'+id).show();
}

function deliveryTypeListInit(){
	var id,
		element,
		item_checked = $('.delivery-type-list .item.item-checked');

	function showActiveElement() {
		var active_element = $('.delivery-type-list .item.item-checked'),
			id = active_element.find('input[type="radio"]').data('index');

		$('.delivery-descriptions .descr-item').hide();
		$('.delivery-descriptions .item-'+id).addClass('item-checked').show();
		listItemReady();
	}
	function isRadioChecked(element) {
		return element.find('input[type="radio"]').attr('checked');
	}
	function showSmallActiveElemenet(element, action) {
		if(isRadioChecked(element) != 0) {
			if (action == 'add') {
				element.addClass('item-checked-not-hovered');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-hovered');
			}
		} else {
			if (action == 'add') {
				element.addClass('item-checked-not-default');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-default');
			}
		}
	}
	function setDescriptionMinHeight() {
		var $desc = $('.delivery-descriptions');
		$desc.find('.descr-item').css({
			'min-height' : $desc.height()
		});
	}
	function listItemReady(){
		if ($('.delivery-type-list').length > 0) {
			var deliveryMenuHeight = $('.delivery-type-list .menu-delivery').outerHeight();
			var deliveryTabHeight = $('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').outerHeight();
			if (deliveryTabHeight < deliveryMenuHeight) {
				$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').height(deliveryMenuHeight-14).addClass('item-ready');
			}
			$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').addClass('item-ready');
		}
	}
	setDescriptionMinHeight();
	listItemReady();
	$('.delivery-type-list .item').not('.item-checked').hover(function() {
		var $this = $(this);

		$this.addClass('item-hovered');
		id = $this.find('input[type="radio"]').data('index');
		element = $('.delivery-descriptions .item-'+id).addClass('item-hovered');

		$('.delivery-descriptions .descr-item').hide();
		element.show();

		listItemReady();

		showSmallActiveElemenet(item_checked, 'add');
	}, function() {
		$(this).removeClass('item-hovered');
		if(element){
			element.removeClass('item-hovered');
		}

		item_checked.removeClass('item-checked-not-hovered');

		showActiveElement();

		showSmallActiveElemenet(item_checked, 'remove');
	});
	$('.delivery-type-list .item').click(function(){
		var input=$(this).find('input[name="deliveryType"]');
		if(!input.is(':disabled')){
			input.prop('checked',true)[0].click();
		}
	});
}

function cartStart(account){ // TODO z EUROTMSI-1171: do weryfikacji czy jeszcze używane w KME (customer-erp-order-preview-view.jsp)

	previewStart();
	disableListRadio();
	showProductAccessories();
	deliveryTypeListInit();

	$('tr.prod:odd').addClass('odd');
	$('tr.prod').each(function(){
		$(this).prev().children('td').not('.u').addClass('pB15');
	});
	$('.cart_summarize tr:last td').not('.u').addClass('pB15');
	$('.cart_summarize tr.small').each(function(){
		if(!($(this).next().hasClass('small')))$(this).children('.list').addClass('lastlist');
	});

	$('.radiogroup input:disabled').parent().children('jquery-safari-radio').css('opacity','0.3');
	$('.radiogroup input:disabled').parent().children('label').css('color','#7f7f7f');

	$('tr .quantity input.int, .js-warranty-quantity').blur(function(){
		var maxQuantity = $(this).data('max')/1;
		var currentValue = $(this).val()/1;
		if (maxQuantity && currentValue > maxQuantity) {
			$(this).val(tmpValue/1);
			return;
		}

		if(!$(this).val()>0){
			$(this).val(tmpValue/1);
		}

	}).focus(function(){
		tmpValue=$(this).val();
	}).keyup(function(event){
		if(event.keyCode == 13){
			var maxQuantity = $(this).data('max')/1;
			var currentValue = $(this).val()/1;
			if (maxQuantity && currentValue > maxQuantity) {
				$(this).val(tmpValue/1);
				return;
			}
			if(!$(this).closest('.prod').length) {
				$(this).blur();
			} else {
				$(this).attr('warrantiesMake','1');
			}
		}
		if($(this).val()=='0')$(this).val(1);
	});
	$('.message').each(function(){
		if($(this).children().length==0)$(this).remove();
	});
	if(!account){

		$('.cart_summarize tr').each(function(){
			$(this).children(':first').addClass('bL0');
		});
	}else{
		$(".int").keyfilter(/[\d]/);
	}
}

function zamawiam(){

	if(www.pageType == "cart" && window.sessionStorage.getItem('operator-logged')==="true") {
		if(!updateWarrantyQuestionnaire()){
			return false;
		}
	}

	if(showInstalmentOrdersRequiringActionsForNextAction && $('#instalmentOrdersRequiringActions').length){
		instalmentOrdersRequiring();
		return false;
	}

	if(!$('input[name="deliveryType"]:checked').length){
		$('.order_navigate').addClass('error');
		return false;
	}

	checkWarrantyUA();
	if (servicesInExcludedDeliveryEncouragement) {
		return false;
	}

	if (showNotAddedServices){
		return false;
	}

}

function dalejGo(){
	loadingStart();
	$('#F_ACTION').val('NEXT');
	$('#frontForm').submit();
}

function dalej(s){

	if($('#frontForm').valid()){

		if(typeof window.showHomeAddress != "undefined" && window.showHomeAddress==true)var showHomeAddress=true;
        else var showHomeAddress=false;

        if(typeof window.showInvoiceData != "undefined" && window.showInvoiceData==true)var showInvoiceData=true;
        else var showInvoiceData=false;

		if(s=='S' && showHomeAddress==true && $('#zipCode').length && $('#zipCode').val()!=''){

			$.ajax({
                url: '/order-path-validate-address-integrity.ltr',
				dataType: 'json',
				async: false,
				data: {
					cityName: $('#cityName').val(),
					zipCode: $('#zipCode').val(),
					street: $('#homeAddressStreet').val(),
					isDelivery: false,
					deliveryCityName: '',
					deliveryZipCode: '',
					deliveryAddressStreet: '',
					isInvoice: false,
					invoiceCityName: '',
					invoiceZipCode: '',
					invoiceAddressStreet: ''
				},
				success: function(data) {

					var message = data.message;

					if (message != "") {
                        if(!data.blockNextStep) {
							showModalAddressError(data, function(){dalejGo()});
                        } else {
                            showModalBlockPayment(data);
                        }
					}
					else {
						dalejGo();
					}
				}
			});

		}

		if(s=='S' && showInvoiceData==true && ($('#faktura:checked').length || $('#faktura input:checked').length) && $('#invoiceZipCode').length && $('#invoiceZipCode').val()!=''){

			$.ajax({
                url: '/order-path-validate-address-integrity.ltr',
				dataType: 'json',
				async: false,
				data: {
					cityName: $('#invoiceCityName').val(),
					zipCode: $('#invoiceZipCode').val(),
					street: $('#invoiceAddressStreet').val(),
					isDelivery: false,
					deliveryCityName: '',
					deliveryZipCode: '',
					deliveryAddressStreet: '',
					isInvoice: false,
					invoiceCityName: '',
					invoiceZipCode: '',
					invoiceAddressStreet: ''
				},
				success: function(data) {

					var message = data.message;

					if (message != "") {
                        if(!data.blockNextStep) {
							showModalAddressError(data, function(){dalejGo()});
                        } else {
							showModalBlockPayment(data);
						}
					}
					else {
						dalejGo();
					}
				}
			});
		}
		else{
			dalejGo();
		}
	}else{
		scrollToError();
	}
}

function gotoZipCode(invalidZipCodeSelector){
	$(invalidZipCodeSelector).focus();
	$.scrollTo(invalidZipCodeSelector,800);
}

function disableListRadio(){
	$('input:radio, input:checkbox').each(function(){
		if($(this).prop('disabled')){
			$(this).parent().find('span, img').unbind('click');
			$('label[for='+$(this).attr('id')+']').unbind('click');
		}
	});
}


function nextLogin(login) {
	//todo: do validate email format
	//check user exists
	var login = $('#j_username').val();
	var loginValid = $('#loginForm').validate().element('#j_username');
	var $captcha = $('#loginForm #g-recaptcha-response');
	var captchaValid = $captcha.length ? $('#loginForm').validate().element('#g-recaptcha-response') : true;

	if(loginValid && captchaValid){
		loadingStart();
		$.ajax({
			url : '/front-user-account-exist.ltr',
			dataType : 'json',
			async : false,
			data : {
				email : login
			},
			success : function(json) {

				$('#email-block').hide();
				if (json.exists) {
					newErpOrdersLoginMessage(login);
					$('#password-block').show();
					$('#j_password').focus();
				} else {
					$('#email').val(login);
					newErpOrdersRegistrationMessage(login);
					$('#registration-block').show();
				}
			}
		});
	}
}

function newErpOrdersLoginMessage(login) {
	$.ajax({
		url : '/erp-orders-login-message.ltr',
		dataType : 'json',
		async : false,
		data : {
			login : login
		},
		success : function(json) {
			$('#erp-orders-login-message').html(json.message);
		},
		complete : function(){
			loadingStop();
		}
	});
}
function newErpOrdersRegistrationMessage(login) {
	$.ajax({
		url : '/erp-orders-registration-message.ltr',
		dataType : 'json',
		async : false,
		data : {
			login : login
		},
		success : function(json) {
			$('#erp-orders-registration-message').html(json.message);
		},
		complete : function(){
			loadingStop();
		}
	});
}
function showMessageAgrement(){
	$.fancybox($('#message_agreements_popup').html(),{
		autoDimensions:true,
		onComplete: function(){
			var agreementsForm = $('#command');
			$('#acceptAgreementsPopup').click(function(){
				loadingStart();
				agreementsForm.find('input[type="checkbox"]').attr('checked','checked');
				agreementsForm.submit();
			});
			$('#cancelAgreementsPopup').click(function(){
				loadingStart();
				agreementsForm.submit();
			});
		}
	});
}
function agreementsViewStart(){
	$('.checkNewsletterPolicy').click(function() {
		$.fancybox($('#message_newsletter_policy').html(), {
			autoDimensions:true
		});
	});
	$('#submitAgreements').click(function(e){
		e.preventDefault();
		var agreementsForm = $('#command');
		if(agreementsForm.find('input[type="checkbox"]').length > agreementsForm.find('input[type="checkbox"]:checked').length){
			showMessageAgrement();
		}else{
			agreementsForm.submit();
		}
	});
	$('#selectAllAgreements').click(function(e){
		e.preventDefault();
		$('#command').find('input[type="checkbox"]').prop('checked', true);
	});
	$('#command .more, #command .less').click(function(){
		$(this).parent().toggleClass('moreText');
	});
}

function openAddSourceParam(form, from) {

	$.fancybox({href: '/add-source-param.ltr?operator_form=' + form+'&from='+from},
			{
				autoDimensions : true
			}
	);
}

